import { useIntl } from "react-intl";
import DocumentsData from "../variables/variables.json";
import TranslatedMessage from "./TranslatedMessage";
import Image from "next/image";

import TabsScript from "./js/TabsScript";

const ariaControlsPanelButton = 1;
const idTabButton = 1;
// const idPanelContents = [dokumenty.id]
// const ariaTabContents = [dokumenty.id]

const Tabs = (props) => {
  const intl = useIntl();

  // PROPS VARIABLE
  let propsMiasto = props.miasto;
  let propsPodatek = props.podatek;

  // JSON VARIABLE
  let miastoJSON = DocumentsData.miasta[propsMiasto];

  return (
    <>
      {/* {miastoJSON.documents.map((item, index) => {
        return (
          <li key={index}>
            {item[propsPodatek].map((propsPodatek, index) => (
              <div key={index}>
                {propsPodatek.year}

                {propsPodatek.dokumenty.map((dokumenty, index) => (
                  <div key={index}>{dokumenty.date}</div>
                ))}
              </div>
            ))}
          </li>
        )
      })} */}

      <div className="pd-tabs tabs">
        {miastoJSON.documents.lista.map((item, index) => {
          return (
            <div
              className="pd-tabs__select"
              role="tablist"
              aria-label="Sample Tabs"
              key={index}
            >
              {item[propsPodatek].map((item, index) => (
                <button
                  className="pd-tabs__select__button"
                  role="tab"
                  aria-selected={index == 0 ? true : false}
                  aria-controls={"panel-" + index}
                  id={"tab-" + index}
                  tabIndex="0"
                  key={index}
                >
                  <span className="sr-only">Rok podatkowy: </span>
                  <TranslatedMessage
                    id={"miasta." + propsMiasto + "." + item.year}
                  />
                </button>
              ))}
            </div>
          );
        })}

        {miastoJSON.documents.lista.map((item, index) => {
          return (
            <div className="pd-tabs__contents__wrapper" key={index}>
              {item[propsPodatek].map((item, index) => (
                <div
                  className="pd-tabs__contents"
                  id={"panel-" + index}
                  role="tabpanel"
                  tabIndex="0"
                  aria-labelledby={"tab-" + index}
                  hidden={index == 0 ? false : true}
                  key={index}
                >
                  {item.dokumenty.map((dokumenty, index) => (
                    <div className="row center-xs" key={index}>
                      <div className="pd-tabs__column col-md-2 col-xs-12">
                        <span className="sr-only">Z dnia: </span>
                        <TranslatedMessage
                          id={"miasta." + propsMiasto + "." + dokumenty.date}
                        />
                      </div>
                      <div className="pd-tabs__column pd-tabs__title col-md-8 col-xs-12">
                        <span className="sr-only">Nazwa dokumentu: </span>
                        <TranslatedMessage
                          id={"miasta." + propsMiasto + "." + dokumenty.title}
                        />
                      </div>
                      <div className="pd-tabs__column col-md-2 col-xs-12">
                        <a
                          className="pd-tabs__action"
                          href={intl.formatMessage({
                            id: "miasta." + propsMiasto + "." + dokumenty.url,
                          })}
                          aria-label={
                            "miasta." +
                            propsMiasto +
                            "." +
                            dokumenty.alternativeTitle
                              ? intl.formatMessage({
                                  id:
                                    "miasta." +
                                    propsMiasto +
                                    "." +
                                    dokumenty.alternativeTitle,
                                })
                              : "Podgląd dokumentu o nazwie: " +
                                intl.formatMessage({
                                  id:
                                    "miasta." +
                                    propsMiasto +
                                    "." +
                                    dokumenty.title,
                                })
                          }
                        >
                          <div className="pd-tabs__action__icon__container">
                            <span className="pd-tabs__action__icon pd-tabs__action__icon--normal">
                              <Image unoptimized 
                                src={DocumentsData.documents.action.image}
                                width={26}
                                height={17}
                                alt=""
                              />
                            </span>
                            <span className="pd-tabs__action__icon pd-tabs__action__icon--black">
                              <Image unoptimized 
                                src={DocumentsData.documents.action.imageBlack}
                                width={26}
                                height={17}
                                alt=""
                              />
                            </span>
                            <span className="pd-tabs__action__icon pd-tabs__action__icon--highcontrast">
                              <Image unoptimized 
                                src={
                                  DocumentsData.documents.action.imageContrast
                                }
                                width={26}
                                height={17}
                                alt=""
                              />
                            </span>
                          </div>
                          <span className="pd-tabs__action__text">
                            <TranslatedMessage id="documents.preview" />
                          </span>
                        </a>
                      </div>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          );
        })}
      </div>

      {miastoJSON.documents.lista.map((item, index) => {
        return item[propsPodatek].map((item, index) =>
          index > 0 ? <TabsScript key={index} /> : null
        );
      })}
    </>
  );
};

export default Tabs;
